import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol } from "../../../components/common/UiPageElements";
import knowldgePhoto from '../../../../../styles/img/home-car-img.png';

export const KnowledgePhotos = () => {
    return (
        <>
            <UiContentCol>
                <UiCardTitle title="Photos" fullyUnderlined={true} />
                <div className="sb-knl-photo-sec">
                    <img src={knowldgePhoto} />
                    <img src={knowldgePhoto} />
                    <img src={knowldgePhoto} />

                </div>
            </UiContentCol>
        </>
    )
}